/* eslint-disable class-methods-use-this */
import {
    post,
    get,
    put,
    _delete,
  } from '@/lin/plugins/axios'
  
  const _baseUri = 'plugin/project/salesman/'
  
  class Salesman {
    // constructor() {}
    async add(info) {
      const res = await post(`${_baseUri}`, info)
      return res
    }
  
    async get(id) {
      const res = await get(`${_baseUri}${id}`)
      return res
    }
  
    async edit(id, info) {
      const res = await put(`${_baseUri}${id}`, info)
      return res
    }
  
    async delete(id) {
      const res = await _delete(`${_baseUri}${id}`)
      return res
    }
  
    async gets(pageInfo) {
      const res = await get(`${_baseUri}`, pageInfo)
      return res
    }
  }
  
  export default new Salesman()
  